/* eslint import/prefer-default-export: 0 */

import * as t from './action_types';

/**
 * @param {Boolean} isFetching
 */
export const setTaskUpdateFetchingFlag = isFetching => ({
  type: t.SET_TASK_UPDATE_FETCHING_FLAG,
  payload: { isFetching },
});

/**
 * @param {Object} error
 */
export const setTaskUpdateError = error => ({
  type: t.SET_TASK_UPDATE_ERROR,
  payload: { error },
});

/**
 * @param {Boolean} isFetching
 */
export const setTaskOffersFetchingFlag = isFetching => ({
  type: t.SET_TASK_OFFERS_FETCHING_FLAG,
  payload: { isFetching },
});

/**
 * @param {String} status
 */
export const setTaskUpdateStatus = status => ({
  type: t.SET_TASK_UPDATE_STATUS,
  payload: { status },
});

/**
 * @param {Number} taskId
 */
export const setLastTaskId = taskId => ({
  type: t.SET_LAST_TASK_ID,
  payload: { taskId },
});
